import { getOrganizationById } from "@/frontend/pages/SettingsPage/model/services/getOrganizationById";
import { useQuery } from "@tanstack/react-query";
import { reportErrorToSentry } from "../reportErrorToSentry/reportErrorToSentry";

export function useOrgPhoto(organizationId: number | undefined) {
  if (!organizationId) return undefined;

  const { data } = useQuery({
    queryKey: ["orgData", organizationId],
    queryFn: async () => {
      if (!organizationId) return undefined;
      const data = await getOrganizationById(organizationId);
      return data;
    },
    refetchOnWindowFocus: false,
    throwOnError: (error) => {
      console.error(error);
      reportErrorToSentry(error, "useOrgPhoto");
      return true;
    }
  });

  return data?.profilePhotoImgUrl ? data.profilePhotoImgUrl : undefined;
}
